module.exports = __webpack_public_path__ + "static/media/96balitower.11028eb2.png";